import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, message, Alert } from 'antd';
import { CrownOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const API_BASE_URL = '';

// 系统首次初始化：设置超级管理员账号
const InitPage = ({ onInitialized }) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/init`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: values.username.trim(), pin: values.pin }),
      });
      const data = await res.json();
      if (res.ok) {
        messageApi.success('初始化成功，请使用超级管理员账号登录');
        if (onInitialized) onInitialized();
      } else {
        messageApi.error(data.detail || '初始化失败');
      }
    } catch (e) {
      messageApi.error('初始化失败');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: 'linear-gradient(180deg, #ffecd2 0%, #fcb69f 50%, #a8edea 100%)' }}>
      {contextHolder}
      <Card style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <Title level={3} style={{ color: '#ff6b95', margin: 0 }}>🍁 MapleLegends</Title>
          <Text type="secondary">首次使用，请初始化系统</Text>
        </div>
        <Alert
          type="info"
          showIcon
          icon={<CrownOutlined />}
          style={{ marginBottom: 16 }}
          message="设置超级管理员账号"
          description="超级管理员拥有最高权限（可管理其他管理员与系统配置）。请牢记下面的账号与 PIN 码。"
        />
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="username"
            label="超级管理员用户名"
            rules={[
              { required: true, message: '请输入用户名' },
              { pattern: /^[a-zA-Z0-9]{3,20}$/, message: '3-20 位大小写英文字母或数字' },
            ]}
          >
            <Input placeholder="例如：admin" maxLength={20} autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="pin"
            label="登录 PIN 码（4 位数字）"
            rules={[
              { required: true, message: '请输入 PIN 码' },
              { pattern: /^\d{4}$/, message: '必须是 4 位数字' },
            ]}
          >
            <Input.Password placeholder="4 位数字" maxLength={4} inputMode="numeric" />
          </Form.Item>
          <Form.Item
            name="confirmPin"
            label="确认 PIN 码"
            dependencies={['pin']}
            rules={[
              { required: true, message: '请再次输入 PIN 码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('pin') === value) return Promise.resolve();
                  return Promise.reject(new Error('两次输入的 PIN 码不一致'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="再次输入 PIN 码" maxLength={4} inputMode="numeric" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              初始化系统
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default InitPage;
